import React, { useState } from 'react';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';
import { TermsModal } from '../../TermsModal';
import { OffersDataService } from '../../../../services/offers-data.service';

export const BannerTerms = ({ className }) => {
    const { essentialTnC, fullTnC, mainBannerLayout } =  OffersDataService.getOffersData();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { t } = useTranslations();

    const handleToggleModal = () => setIsModalOpen(prev => !prev);

    return (
        <div className={`${className} ${mainBannerLayout}`}>
            <span className={`${className}__title`}>{t('termsAndConditionsPROMOTION')}</span>

            <div className={`${className}__container`}>
                <span
                    className={`${className}__text`}
                    dangerouslySetInnerHTML={{ __html: `${essentialTnC}... ` }}>
                </span>
                <a
                    onClick={handleToggleModal}
                    className={`${className}__readMore`}
                >
                    {t('readMore')}
                </a>
            </div>

            {isModalOpen &&
                <TermsModal handleToggleModal={handleToggleModal} fullTnC={fullTnC} isModalOpen={isModalOpen} />}
        </div>
    );
};
